var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 583.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b2b2b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.79,33.24c58.15,8.86,70.58,53.97,66.07,106.37-.8,9.32-5.63,18.23-13.15,23.75-3.18,2.33-13.04,5.18-13.59,5.83-.9,1.07-2.53,6.36-3.97,8.66-3.98,6.36-10.98,10.59-8.98,18.37,18.93,9.22,47.03,11.8,58.26,31.56,1.7,2.99,5.66,12.72,5.66,15.7v46.13h-192.27v-46.13c0-.79,1.98-7.85,2.45-9.2,8.76-24.86,38.77-27.92,60.02-37.08,5.68-6.57-3.72-13.25-7.53-19.34-1.44-2.3-3.07-7.59-3.97-8.66-.55-.65-10.41-3.5-13.59-5.83-7.52-5.53-12.34-14.44-13.15-23.75-4.23-49.1,8.39-101.15,66.07-106.37h11.65ZM361.28,109.95c1.73-23.49-11.97-46.79-33.63-56.18-39.62-17.19-81.62,13.95-78.99,56.18,8.26-5.19,18.11-3.4,27.23-5.29,12.61-2.6,20.24-9.75,29.43-17.95,8.26,9.02,18.02,16.07,30.35,18.26,8.61,1.53,17.87,0,25.61,4.97ZM336.96,120.68c-11.8-1.02-22.43-6.36-32.31-12.52-9.31,6.7-20.23,11.32-31.68,12.52,1.4,15.32-3.73,35.1,4.02,48.8,9.66,17.06,32.47,21.62,47.86,9.39,18.44-14.65,10.58-37.67,12.11-58.2ZM257.38,150.74v-27.19c-11.54,4.67-11.8,23.32,0,27.19ZM352.55,150.74c11.89-3.9,11.34-22.41,0-27.19v27.19ZM321.47,199.3c-11.3,2.53-21.71,2.54-33.02,0,5.5,7.33,9.37,17.4,14.72,24.6.6.81.92,1.93,2.26,1.61l16.03-26.21ZM293.31,239.09c.91-1.21-13.79-25.38-14.99-26.3-2.89-2.22-7.85,1.88-11.23,2.04l9.72,31.07,16.5-6.81ZM342.84,214.84c-3.81-.15-7.79-4.64-11.25-2.03-1.21.91-15.89,25.08-14.98,26.28l16.5,6.81,9.72-31.07ZM224.37,244.45c-1.26,8.89.93,20.42,0,29.62h161.2v-29.62c0-1.35-3.06-8.03-4.05-9.55-5.45-8.37-15.24-11.09-24.1-14.25l-16.07,47.61-35.97-17.5-37.3,17.47-15.56-47.59c-11.75,3.55-26.18,9.92-28.15,23.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.37,322.62h160.23v207.81H56.37v-207.81ZM201.06,338.15H71.91v175.28l1.46,1.46h127.7v-176.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.95,306.15l4.9,23.27c1.83,1.78,19.1-10.77,22.67-11.51l41.93,41.59-11.15,21.77,23.22,6.45-.08,59.55c-.7,2.05-19.65,6.09-23.19,6.44-2.03,2.15,10.33,18.75,11.25,22.39l-42.32,42.25c-1.55.69-19.87-13.61-22.33-11.24-.35,3.54-4.39,22.48-6.44,23.18l-59.55.08-5.81-22.85c-2.95-2.2-17.87,10.82-22.41,10.79l-41.3-41.33c-1.31-2.63,13.3-21.15,11.22-23.27l-23.31-4.87-.06-60.58,22.95-6.36c.93-1.04.31-1.91-.09-2.93-1.32-3.34-11.39-16.8-11-18.84l41.64-41.95c2.69-1.34,17.42,10.96,21.76,11.21l6.46-23.2,61.04-.05ZM459.24,321.77h-35.19c-2.82.96-3.66,16.46-5.71,19.05-.47.6-12.94,5.71-14.09,5.9-4.93.81-16.59-10.05-18.7-9.1l-25,25.28,9.48,16.59-5.76,15.3-19.37,6.12v35.19s19.29,5.47,19.29,5.47c.54.52,5.54,12.76,5.67,13.86.58,4.78-10.17,16.28-9.09,18.69l24.51,24.13,18.25-9.22,14.05,5.98,6.5,19.92,35.19-.14,5.44-19.32,14-6.34c4.9.4,15.3,10.69,19.46,8.8,3.09-4.68,22.22-19.96,23.21-23.56,1.03-3.73-8.23-13.85-9.22-18.24,2.96-4.14,4.02-13.56,8.36-15.55,2.66-1.21,17.14-3.33,17.54-5l-.47-35.35-18.97-5.3-6.64-14.72c1.08-4.29,10.81-14.93,9.08-18.73l-24.3-24.04-16.57,9.43-14.97-5.37-5.99-19.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.41,153.65h-40.3c-.4,0-5.2,4.7-4.42,6.26l.1,142.85-1.51,3.35h-14.08v-151c0-1.96,5.39-9.5,7.26-11.19s8.55-5.8,10.71-5.8h41.27c.42-1.69-.7-1.94-1.45-2.92-2.39-3.12-14.41-13.17-14.95-15.24-.78-2.96,8.24-9.28,10.09-11.93l37.37,37.37-37.37,37.37-10.13-11.02,17.41-18.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.42,262.41l18.1-17.41,10.96,10.96-36.48,36.48-38.21-37.32c2.64-1.86,8.97-10.87,11.93-10.09l18.16,17.38v-101.48c0-1.37-4.43-7.28-5.34-7.28h-43.21v-15.54h46.13c6.87,0,17.96,14.1,17.96,20.88v103.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.53,410.01h60.21v15.54h-60.21c-.42,1.69.7,1.94,1.45,2.92,2.07,2.7,16.01,14.88,16.01,16.02l-11.15,11.15-36.45-37.37,36.58-37.32,10.96,10.96-17.41,18.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.41,
    y: 354.66,
    width: 96.14,
    height: 15.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.41,
    y: 418.75,
    width: 96.14,
    height: 15.54
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.41,
    y: 450.8,
    width: 96.14,
    height: 15.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.46,
    y: 386.71,
    width: 64.09,
    height: 15.54
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.41,
    y: 482.85,
    width: 64.09,
    height: 15.54
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.01,
    y: 482.85,
    width: 15.54,
    height: 15.54
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.99,354.93c72.78-8.73,101.69,84.4,42.62,118.37-49.5,28.47-107.38-15.61-94.37-71.06,5.42-23.08,28-44.45,51.75-47.3ZM432.91,370.45c-57.87,7.83-50.6,102.51,14.19,95.77,61.36-6.38,54.07-105-14.19-95.77Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.86,386.96c51.22-7.44,49.49,70.27.18,62.43-33.92-5.39-33.04-57.66-.18-62.43ZM436.77,402.47c-15.42,3.18-15.66,29.54,1.81,31.73,25.77,3.24,24.81-37.22-1.81-31.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.93602ea59ac9e59825761a2a56350054.svg";
export { ForwardRef as ReactComponent };